import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
const VARIANT_CLASS = {
    primary: 'btn btn--primary',
    secondary: 'btn',
    ghost: 'btn btn--ghost',
    danger: 'btn btn--danger',
    success: 'btn btn--primary',
};
const SIZE_STYLE = {
    sm: { height: 24, padding: '0 8px', fontSize: 11.5 },
    md: { height: 30, padding: '0 12px', fontSize: 12.5 },
};
/**
 * Canonical button. Maps to `.btn` + variant modifier from shell.css. `success`
 * variant currently aliases to `primary` since the canonical design language
 * has no separate "success" colour for buttons (success-green is reserved for
 * status badges and run-dots).
 */
export const Button = forwardRef(function Button({ variant = 'secondary', size = 'md', icon, trailingIcon, iconOnly, className = '', children, type, style, ...rest }, ref) {
    const sizeStyle = SIZE_STYLE[size];
    const cls = `${VARIANT_CLASS[variant]}${iconOnly ? ' btn--icon-only' : ''}` +
        (className ? ` ${className}` : '');
    const finalStyle = {
        height: sizeStyle.height,
        fontSize: sizeStyle.fontSize,
        ...(iconOnly
            ? { width: sizeStyle.height, padding: 0 }
            : { padding: sizeStyle.padding }),
        ...style,
    };
    return (_jsxs("button", { ref: ref, type: type ?? 'button', className: cls, style: finalStyle, ...rest, children: [icon ? _jsx("span", { style: { display: 'inline-flex', flexShrink: 0 }, children: icon }) : null, !iconOnly && children ? _jsx("span", { style: { overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }, children: children }) : null, iconOnly && children ? _jsx("span", { style: { position: 'absolute', width: 1, height: 1, overflow: 'hidden', clip: 'rect(0,0,0,0)' }, children: children }) : null, trailingIcon ? _jsx("span", { style: { display: 'inline-flex', flexShrink: 0 }, children: trailingIcon }) : null] }));
});
//# sourceMappingURL=Button.js.map